/* __next_internal_client_entry_do_not_use__ ModalNavigationAbsolute auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import * as React from "react";
import styled, { useTheme } from "styled-components";
import { IconButton } from "../../IconButton";
import { Chevron } from "../../icons/foundation/Chevron";
import { Close } from "../../icons/foundation/Close";
import { getSpacing } from "../../spacing";
export var ModalNavigationAbsolute = function(param) {
    var onClose = param.onClose, onBack = param.onBack, onForward = param.onForward, primary = param.primary, showCloseButton = param.showCloseButton, closeButtonVariant = param.closeButtonVariant, closeIconProps = param.closeIconProps, backIconProps = param.backIconProps, forwardIconProps = param.forwardIconProps;
    var _theme_modals;
    var theme = useTheme();
    var modalTheme = (_theme_modals = theme.modals) === null || _theme_modals === void 0 ? void 0 : _theme_modals[primary ? "primary" : "default"];
    var _modalTheme_color;
    var iconColor = (_modalTheme_color = modalTheme === null || modalTheme === void 0 ? void 0 : modalTheme.color) !== null && _modalTheme_color !== void 0 ? _modalTheme_color : Core.icon.default;
    var _modalTheme_iconProps;
    var iconProps = (_modalTheme_iconProps = modalTheme === null || modalTheme === void 0 ? void 0 : modalTheme.iconProps) !== null && _modalTheme_iconProps !== void 0 ? _modalTheme_iconProps : {};
    var strictLocalize = useStrictLocalization().strictLocalize;
    var closeText = strictLocalize({
        id: "sqyFFG",
        defaultMessage: [
            {
                type: 0,
                value: "Close"
            }
        ]
    });
    var previousText = strictLocalize({
        id: "E8zXjQ",
        defaultMessage: [
            {
                type: 0,
                value: "Previous"
            }
        ]
    });
    var nextText = strictLocalize({
        id: "t+MKgo",
        defaultMessage: [
            {
                type: 0,
                value: "Next"
            }
        ]
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            showCloseButton && onClose ? /*#__PURE__*/ _jsx(CloseButton, {
                "aria-label": closeText,
                className: "closeButton",
                onClick: onClose,
                "data-test-id": "modalCloseButton",
                variant: closeButtonVariant !== null && closeButtonVariant !== void 0 ? closeButtonVariant : "tertiary",
                style: {
                    margin: closeButtonVariant === "secondary" ? getSpacing("2x") : undefined
                },
                children: /*#__PURE__*/ _jsx(Close, _object_spread({
                    color: iconColor
                }, iconProps, closeIconProps))
            }) : null,
            onBack ? /*#__PURE__*/ _jsx(BackButton, {
                "aria-label": previousText,
                className: "backButton",
                onClick: onBack,
                "data-test-id": "modalBackButton",
                variant: "tertiary",
                children: /*#__PURE__*/ _jsx(Chevron, _object_spread({
                    direction: "left",
                    color: iconColor
                }, iconProps, backIconProps))
            }) : null,
            onForward ? /*#__PURE__*/ _jsx(ForwardButton, {
                "aria-label": nextText,
                className: "forwardButton",
                onClick: onForward,
                "data-test-id": "modalForwardButton",
                variant: "tertiary",
                children: /*#__PURE__*/ _jsx(Chevron, _object_spread({
                    direction: "right",
                    color: iconColor
                }, iconProps, forwardIconProps))
            }) : null
        ]
    });
};
var CloseButton = styled(IconButton).withConfig({
    componentId: "sc-b8357b92-0"
})([
    "position:absolute;right:0;top:0;z-index:1;"
]);
var BackButton = styled(IconButton).withConfig({
    componentId: "sc-b8357b92-1"
})([
    "left:0;position:absolute;top:0;z-index:1;"
]);
var ForwardButton = styled(IconButton).withConfig({
    componentId: "sc-b8357b92-2"
})([
    "left:64px;position:absolute;top:0;z-index:1;"
]);
